import { FC } from 'react'
import { NavigationLink } from '@/store/NavigationMenu/NavigationTypes'
import Link from 'next/link'
import { useMarketingUrl } from '@/hooks/MarketingUrl'
import styles from './NavigationLinkThirdLevelMobile.module.scss'

interface NavigastionLinkTirdLevelMobileProps {
  item: NavigationLink
  onLinkClick?: () => void
}
export const NavigationLinkThirdLevelMobile: FC<
  NavigastionLinkTirdLevelMobileProps
> = ({ item, onLinkClick }) => {
  const marketingUrl = useMarketingUrl()
  const href = marketingUrl(item.href ?? '')

  if (item.href == null) {
    return null
  }

  return (
    <>
      <Link className={styles.container} href={href} onClick={onLinkClick}>
        <span className={styles.title}>{item.title}</span>
        {item.price != null ? (
          <span className={styles.price}>
            {new Intl.NumberFormat('ru-RU').format(item.price)} ₽
          </span>
        ) : null}
      </Link>{' '}
    </>
  )
}
